import React from 'react';
import * as ReactDOM from 'react-dom'; // eslint-disable-line react/no-find-dom-node
import listenDOM from 'dom-helpers/events/listen';

type Child = Element | Text | null;

export interface Props {
  events?: string | string[];
  page: string;
  name: string;
  onTrack: (name: string, params: object) => void;
  getDynamicData?: (event: string) => object;
  children: React.ReactNode;
  [K: string]: any;
}

class Track extends React.Component<Props> {
  static defaultProps = {
    events: ['click'],
  };

  mountedChild: Child;

  unlistens: (() => void)[] | null;

  componentDidMount() {
    this.mountedChild = ReactDOM.findDOMNode(this);
    this.attachEventsTo(this.mountedChild);
  }

  componentDidUpdate() {
    const child = ReactDOM.findDOMNode(this);

    if (child !== this.mountedChild) {
      this.detachEvents();
      this.attachEventsTo(child);
      this.mountedChild = child;
    }
  }

  componentWillUnmount() {
    this.detachEvents();
    this.mountedChild = null;
    this.unlistens = null;
  }

  onEvent = (event: string) => {
    const { name, onTrack, getDynamicData, ...restProps } = this.props;
    // eslint-disable-next-line prefer-object-spread
    const params = Object.assign(
      {},
      restProps,
      getDynamicData && getDynamicData(event),
    );

    delete params.events;
    delete params.children;

    onTrack(name, params);
  };

  attachEventsTo(element: Child) {
    const eventsProp = this.props.events || '';
    const events = Array.isArray(eventsProp)
      ? eventsProp
      : eventsProp.split(' ');

    this.unlistens = events.map(event =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (listenDOM as any)(element, event, this.onEvent, false),
    );
  }

  detachEvents() {
    if (this.unlistens) {
      this.unlistens.forEach(unlisten => unlisten());
    }
  }

  render() {
    return this.props.children;
  }
}

export default Track;
